export default {
  methods: {

    validateRequestAsDraft () {
      this.swalConfirm({
        html: () => {
          if (this.editing) {
            return 'Update changes on this Draft?'
          }

          return 'Save Stock Transfer as Draft?'
        },
        customClass: {
          confirmButton: 'btn btn-sm btn-secondary'
        },
        preConfirm: () => {
          const createOrUpdate = () => {
            return this.editing ? this.updateDraft() : this.submitDraft()
          }

          return createOrUpdate().catch(
            errors => {
              if (errors.errors) {
                this.setProductErrors(errors.errors)
                this.$refs.formDelivery.setErrors(errors.errors)
                this.$refs.formStockRequest.setErrors(errors.errors)
              }
            }
          )
        },
        confirmButtonText: this.editing ? 'Update' : 'Save'
      })
    },

    submitDraft () {
      const { id, headers, delivery_details } = this.stockRequest
      return this.$refs.srDraft.create({
        id: id,
        headers: {
          withdrawal: headers.withdrawal,
          withdrawal_transaction_number: headers.withdrawal_transaction_number,
          destination: headers.destination,
          destination_name: headers.destination_name,
          destination_code: headers.destination_code,
          remarks: ''
        },
        delivery_details: {
          date: delivery_details.date,
          vehicle: delivery_details.vehicle,
          vehicle_plate: delivery_details.vehicle_plate,
          vehicle_name: delivery_details.vehicle_name,
          driver: delivery_details.driver,
          driver_name: delivery_details.driver_name,
          mobile_number: delivery_details.mobile_number,
          is_3pl: delivery_details.is_3pl,
          helper: delivery_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        is_draft: 1,
        active: 1
      }).then(() => {
        this.currentTabIndex = 1
      })
    },

    updateDraft (isDraft = 1, remarks = '') {
      const { id, headers, delivery_details } = this.stockRequest
      return this.$refs.srDraft.update({
        id: id,
        headers: {
          withdrawal: headers.withdrawal,
          withdrawal_transaction_number: headers.withdrawal_transaction_number,
          destination: headers.destination,
          destination_name: headers.destination_name,
          destination_code: headers.destination_code,
          remarks: remarks
        },
        delivery_details: {
          date: delivery_details.date,
          vehicle: delivery_details.vehicle,
          vehicle_plate: delivery_details.vehicle_plate,
          vehicle_name: delivery_details.vehicle_name,
          driver: delivery_details.driver,
          driver_name: delivery_details.driver_name,
          mobile_number: delivery_details.mobile_number,
          is_3pl: delivery_details.is_3pl,
          helper: delivery_details.helper
        },
        details: this.$refs.componentProducts.getFinalProducts(),
        is_draft: isDraft,
        active: 1
      }).then(() => {
        this.currentTabIndex = Number(isDraft)
      })
    }
  }
}
